<template>
    <div class="d-flex">
        <navigator></navigator>
         <OnboardingWrapper>
        <div id='gamedetail-page'>
            <div class="title-header">
				<h1> Project Details </h1>
			</div>
            <!-- <div>
                <transition name="fade">
                    <Loading v-if="isLoading"></Loading>
                </transition>
            </div> -->

<div class="content-wrapper" :class="{ 'is-results-expanded': isSidebarHidden }">
    <sidebar
        v-if="!isSidebarHidden"
        id="gamedetail-sidebar"
        :sideBarType="0"
        @clicked="onClickSidebar" />

<div class="main-content" :style="isSidebarHidden ? 'width: 100%; margin: 0;' : ''">
    <div class="game-detail-analysis-wrapper" v-if="showTitle">
        <router-view :detail="detail" @toggle-sidebar="handleSidebarToggle"/>
    </div>
</div>
</div>
        </div>
    </OnboardingWrapper>
    </div>
</template>

<script>
    import navigator from '../layout/NavBarNew.vue'
    import sidebar from '../layout/SideBar.vue'
    import gameTester from './GameTester.vue'
    import Loading from '../loading/index.vue'
    import GamesObject from "../../Firestore/GamesObject";
    import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue';
    import { onboardingService } from '@/services/OnboardingService';
    import { initializePageOnboarding } from '@/services/onboardingConfigs';
    export default {
        name: "gamedetail",
        components: {
            navigator,
            sidebar,
            gameTester,
            Loading,
            OnboardingWrapper
        },
        data() {
            // Return the game detail object which holds all details of a game such as its ID and name.
            return {
                isSidebarHidden: false,
                msg: "gamedetail",
                showTitle: false,
                isLoading: false,
                navFlag: -1,
                // Set user type to -1 since it is not set yet
                userType: -1,  // 0: Tester, 1: Company, 2: Admin
                idx: 0,
                // All game details
                detail: {
                    gameId: "",
                    gameName: "",
                    company: "",
                    img: "",
                    endTime: "",
                    description: "",
                    // QA lead for the game
                    qaLead: {
                        name: "",
                        workPhone: "",
                        mobile: "",
                        email: "",
                    },
                    // Number of testers for the game
                    testerNum: 0,
                    // List of IDs of all testers for the game
                    testerIds: [],
                    analysis: {},
                    recordings: {},
                },
            }
        },
        mounted() {
            console.log("✅ mounted reached");
            let that = this;
            // If valid logged in user
            if (window.localStorage.getItem("userType")) {
                // Set user
                this.userType = parseInt(window.localStorage.getItem("userType"));
                this.isLoading = true;
                // Get project which is associated gameId
                GamesObject.getProject(window.localStorage.getItem("gameId"))
                .then(res => {
                    this.project = res.data
                    this.isLoading = false;
                    that.detail = res.data;
                    that.showTitle = true;
                    console.log("userType =", this.userType);
                    if (this.userType === 1) {
                        console.log("✅ calling onboarding for projectDetail");
                    this.$nextTick(() => {
                        initializePageOnboarding(
                        'projectDetail',
                        this.userType,
                        onboardingService,
                        this.$store
                        );
                    });
                    }
                })
                .catch(error => {
                console.log(error);

            });
            // User not logged in
            } else {
                this.$router.push({
                    name: 'login',
                })
            }
        },
        methods: {
            onClickSidebar(index) {
                this.idx = index;
            },
            handleSidebarToggle(shouldHide) {
                this.isSidebarHidden = shouldHide;
            }
        }
    }
</script>

<style scoped>
#gamedetail-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #EEEEEE;
    overflow: hidden;
}

/* Scrollbar styles inherited from global App.vue */

.content-wrapper {
    width: 100%;
    height: 100%;
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}

.content-wrapper.is-results-expanded {
    margin-top: 1rem;
}

@media only screen and (max-width: 1330px) {
  .content-wrapper {
    position: fixed;
    overflow-x: scroll;
    width: 1330px;
  }
}

#gamedetail-sidebar {
    width: 15%;
    height: 75vh;
    display: inline-block;
    vertical-align: top;
    background-color: transparent;
}

.main-content {
    width: 82%;
    height: 80%;
    display: inline-block;
    vertical-align: top;
    margin: 0 2rem 0 2rem;
}

.game-detail-analysis-wrapper {
    height: 100%;
    width: 100%;
}

.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  width: 100%;
  box-shadow: 0 4px 10px -6px grey;
}

.title-header h1 {
	color: #FF7222;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/game-detail/GameDetail.vue